import { IconProps } from 'src/utils/icon';

const ExportIcon: React.FC<IconProps> = ({ size = 1, fill = '#2c2a29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    fill="none"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.269 0L16.98.009a.731.731 0 00-.731.73v1.692a.733.733 0 00.746.732l3.739-.138.105.104L6.679 17.291a.609.609 0 000 .863l1.168 1.168a.61.61 0 00.863 0L22.87 5.16l.105.105-.138 3.739a.734.734 0 00.732.746h1.691a.731.731 0 00.731-.731L26 .73A.731.731 0 0025.269 0zm-3.331 14.625h-.813a.812.812 0 00-.813.813v7.82a.305.305 0 01-.304.305H2.742a.305.305 0 01-.304-.305V5.992a.305.305 0 01.304-.304h7.82a.812.812 0 00.813-.813v-.813a.812.812 0 00-.813-.812H2.438A2.437 2.437 0 000 5.688v17.875A2.437 2.437 0 002.438 26h17.875a2.438 2.438 0 002.437-2.438v-8.125a.812.812 0 00-.813-.812z"
      fill={fill}
    />
  </svg>
);

export default ExportIcon;
